import React from 'react';
import PropTypes from 'prop-types';
import BentoGrid from '../ui/BentoGrid';
import DashboardOverview from './DashboardOverview';
import MetricsOverview from './metrics/MetricsOverview';
import SplitMetrics from './metrics/SplitMetrics';
import TransactionMetrics from './metrics/TransactionMetrics';
import SharedWalletMetrics from './metrics/SharedWalletMetrics';
import BadgeMetrics from './metrics/BadgeMetrics';
import PhoneAuthMetrics from './metrics/PhoneAuthMetrics';
import { useBentoSelection } from '../../hooks/useBentoSelection';

/**
 * Dashboard Bento Grid Component
 * Organizes dashboard metrics in a bento-style layout
 * Now uses DashboardOverview as the default landing page
 */
const DashboardBento = ({ period, platform, compact, useOverview = true }) => {
  // Always call hooks at the top level (React rules)
  const { selected, toggleItem } = useBentoSelection(['overview']);

  // If overview is enabled, use the new overview page
  if (useOverview) {
    return <DashboardOverview period={period} platform={platform} compact={compact} />;
  }

  // Otherwise, use the original bento grid layout

  // Apply compact class to the container
  const containerClass = compact ? 'bento-grid-compact' : '';

  const items = [
    { 
      id: 'overview', 
      label: 'Overview', 
      cols: 12, 
      rows: 2, 
      content: <MetricsOverview period={period} platform={platform} compact={compact} /> 
    },
    { 
      id: 'splits', 
      label: 'Splits', 
      cols: 6, 
      rows: 2, 
      content: <SplitMetrics period={period} compact={compact} /> 
    },
    { 
      id: 'transactions', 
      label: 'Transactions', 
      cols: 6, 
      rows: 2, 
      content: <TransactionMetrics period={period} compact={compact} /> 
    },
    { 
      id: 'shared-wallets', 
      label: 'Shared Wallets', 
      cols: 6, 
      rows: 2, 
      content: <SharedWalletMetrics period={period} compact={compact} /> 
    },
    { 
      id: 'badges', 
      label: 'Badges', 
      cols: 6, 
      rows: 2, 
      content: <BadgeMetrics period={period} compact={compact} /> 
    },
    { 
      id: 'phone-auth', 
      label: 'Phone Auth', 
      cols: 6, 
      rows: 2, 
      content: <PhoneAuthMetrics period={period} compact={compact} /> 
    },
  ];

  return (
    <BentoGrid items={items} onToggleItem={toggleItem} selected={selected} />
  );
};

DashboardBento.propTypes = {
  period: PropTypes.string.isRequired,
  platform: PropTypes.string,
  compact: PropTypes.bool,
  useOverview: PropTypes.bool
};

DashboardBento.defaultProps = {
  platform: null,
  compact: false,
  useOverview: true
};

export default DashboardBento;

